import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { BusinessServiceFilter, HypervisorFilter, StatusFilter, TimeRangeFilter } from '../../filters';
import VirtualMachineListPanel from '../../panels/ipm-list-panels/VirtualMachineListPanel';

export const pageId = 'vmware-vms';

export default function VirtualMachinesPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Virtual Machines`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <BusinessServiceFilter />
                    <HypervisorFilter />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <VirtualMachineListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
